import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { Avatar, Box, List, ListItemAvatar, ListItemButton, Pagination, Skeleton } from '@mui/material';
import { FileOpenOutlined } from '@mui/icons-material';

import { useAppDispatch, useAppSelector } from 'src/redux-app-hooks';
import { DocumentTemplateDto } from '../document-generation.dto';
import { loadDocumentTemplates, selectTemplate } from './document-generation-new-document.slice';

export default function SelectTemplate() {
    const dispatch = useAppDispatch();
    const { templatesResponse } = useAppSelector((state) => state.documentGenerationNewDocument);

    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        dispatch(
            loadDocumentTemplates({
                page: Number(searchParams.get('page')) || 1,
                size: Number(searchParams.get('size')) || 10,
                sort: searchParams.get('sort') || 'desc',
            }),
        );
    }, [searchParams, dispatch]);

    function handleSelectTemplate(template: DocumentTemplateDto) {
        console.debug('handleSelectTemplate');
        dispatch(selectTemplate(template));
    }

    function changePage(page: number) {
        setSearchParams((prev) => {
            const params = new URLSearchParams(prev);
            params.set('page', page.toString());
            return params;
        });
    }

    return (
        <>
            {!templatesResponse && <Skeleton variant="rectangular" height={500} />}

            <List>
                {templatesResponse?.content.map((template) => (
                    <ListItemButton key={template.id} onClick={() => handleSelectTemplate(template)}>
                        <ListItemAvatar>
                            <Avatar>
                                <FileOpenOutlined />
                            </Avatar>
                        </ListItemAvatar>
                        {template.name}
                    </ListItemButton>
                ))}
            </List>

            {templatesResponse && (
                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                    <Pagination
                        variant="outlined"
                        count={templatesResponse.totalPages}
                        page={Number(searchParams.get('page') || 1)}
                        onChange={(_, page) => changePage(page)}
                    />
                </Box>
            )}
        </>
    );
}
